import * as LaunchDarkly from '@launchdarkly/js-client-sdk';
import {
  FirstMatchStrategy,
  MultiProvider,
  type Provider,
} from '@openfeature/web-sdk';

import type { MultiProviderConfig, OnError } from '../types';
import { LaunchDarklyProvider } from './LaunchDarklyProvider';
import { OverrideProvider } from './OverrideProvider';

export function createMultiProvider(
  config: MultiProviderConfig,
  onError?: OnError,
): MultiProvider {
  const providers: Array<{ provider: Provider }> = [];

  // Skip LaunchDarkly initialization in e2e tests so the OverrideProvider is
  // authoritative. Playwright specs signal via `window.__E2E_SKIP_REMOTE_FLAGS__`.
  // oxlint-disable-next-line typescript/no-explicit-any -- Pre-existing usage; CEXP-20389
  const w = typeof window !== 'undefined' ? (window as any) : undefined;
  const isE2E = Boolean(w?.__E2E_SKIP_REMOTE_FLAGS__);

  const overrideProvider = new OverrideProvider(config.override, onError);
  providers.push({ provider: overrideProvider });

  if (!isE2E) {
    const ldClient = LaunchDarkly.createClient(
      config.launchDarkly.clientSideId,
      config.launchDarkly.context,
      config.launchDarkly.options,
    );

    const launchDarklyProvider = new LaunchDarklyProvider(
      { ldClient, bootstrap: config.launchDarkly.bootstrap },
      onError,
    );
    providers.push({ provider: launchDarklyProvider });
  }

  return new MultiProvider(providers, new FirstMatchStrategy());
}
